import script from "./EmojisAndGiphsSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmojisAndGiphsSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./EmojisAndGiphsSwitch.vue?vue&type=style&index=0&id=251e1e61&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-251e1e61"]])

export default __exports__